
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Error extends Vue {
    @Prop({ type: Object, default: null }) private readonly error?: any;
}
